export var BasisEnum;
(function (BasisEnum) {
    BasisEnum["ACCRUAL"] = "Accrual";
    BasisEnum["CASH"] = "Cash";
    BasisEnum["OTHER"] = "Other";
})(BasisEnum || (BasisEnum = {}));
